import React, { useState } from "react";
import Loading from "./Loading";
import {
  usePlayerStats, useSmashThemes, statTiles, StatTiles, SmashRecapModal,
  MODE_SLUGS, modeLabel, fmtDate,
} from "./ProfileStats";
import { t } from "../i18n";
import PageHead from "./PageHead";

// Page des statistiques : à gauche le sélecteur (générales, puis chaque mode),
// au centre le détail chiffré, à droite l'historique — les deux suivent le
// choix. Au Smash or Pass, l'historique liste les thèmes tranchés, chacun avec
// son tableau récapitulatif.
function PlayerStats({ account, onExpired, onBack }) {
  const { stats, error } = usePlayerStats(account, onExpired);
  const smash = useSmashThemes(account);
  const [mode, setMode] = useState(null);          // null = générales
  const [recapTheme, setRecapTheme] = useState(null);

  const head = <PageHead onBack={onBack} title={t("stats.pageTitle")} />;

  if (error) return <>{head}<div class="PlayerStats"><p class="auth-error">{error}</p></div></>;
  if (!stats) return <>{head}<div class="PlayerStats"><Loading label={t("stats.loading")} /></div></>;

  const history = (stats.recent || []).filter(g => !mode || g.game_mode === mode);

  return (
    <>
    {head}
    <div class="PlayerStats">
      <div class="ps-layout">
        <nav class="shop-tabs ps-selector" aria-label={t("stats.pageTitle")}>
          {[null, ...MODE_SLUGS].map(slug => (
            <button key={slug || "all"} type="button"
              class={`shop-tab ps-select${mode === slug ? " active" : ""}`}
              onClick={() => setMode(slug)}>
              {slug ? modeLabel(slug) : t("stats.general")}
            </button>
          ))}
        </nav>

        <section class="ps-panel">
          <h3 class="ps-section-title">{t("stats.detailTitle")}</h3>
          <StatTiles tiles={statTiles(stats, mode, smash)} />
        </section>

        <section class="ps-panel">
          <h3 class="ps-section-title">{t("stats.historyTitle")}</h3>
          {mode === "smashpass" ? (
            <div class="ps-history">
              {(smash || []).map(th => (
                <div key={th.themeId} class="ps-history-row">
                  <div class="ps-history-main">
                    <span class="ps-history-mode">{th.theme}</span>
                    <span class="ps-history-meta">
                      {fmtDate(th.lastAt)} · {t("smash.recapCount", { smash: th.smash, pass: th.pass })}
                    </span>
                  </div>
                  <button class="btn ps-history-btn" onClick={() => setRecapTheme(th.themeId)}>{t("smash.review")}</button>
                </div>
              ))}
              {smash && !smash.length && <p class="stats-empty">{t("stats.emptyHistory")}</p>}
            </div>
          ) : (
            <div class="ps-history">
              {history.map((g, i) => (
                <div key={i} class={`ps-history-row${g.won ? " won" : ""}`}>
                  <div class="ps-history-main">
                    <span class="ps-history-mode">{modeLabel(g.game_mode)}</span>
                    <span class="ps-history-meta">{fmtDate(g.played_at)}</span>
                  </div>
                  {/* Smash or Pass n'a ni score ni classement */}
                  {g.game_mode !== "smashpass" && (
                    <div class="ps-history-result">
                      <b>{g.score}</b>
                      <span>{t("stats.rankOf", { rank: g.rank, count: g.player_count })}</span>
                    </div>
                  )}
                </div>
              ))}
              {!history.length && <p class="stats-empty">{t("stats.emptyHistory")}</p>}
            </div>
          )}
        </section>
      </div>

      {recapTheme && <SmashRecapModal account={account} themeId={recapTheme} onClose={() => setRecapTheme(null)} />}
    </div>
    </>
  );
}

export default PlayerStats;
